$(document).ready(function() {
  $('#js-add-form-field').click(function (event) {
    let hiddenForm = $("#js-dynamic-form-field")
    let formContainer = $("#js-dynamic-form-field-container")
    event.preventDefault();
    formContainer.append(hiddenForm.contents().clone())
  })
});